import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  text: { fontWeight: 600, color: theme.palette.grey[800] },
  slider: {
    color: theme.palette.primary.main, // Red color for the active track
    height: 4,
    '& .MuiSlider-thumb': {
      backgroundColor: theme.palette.primary.main
    },
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}))
export default useStyles
